import styled from "@emotion/styled";
import { colors } from "goi_common";

interface HomeSearchBarProps {
  value: string;
  onChange: (value: string) => void;
}

export const HomeSearchBar = ({ value, onChange }: HomeSearchBarProps) => {
  return (
    <SearchRoot>
      <SearchIcon>
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
          <circle
            cx="11"
            cy="11"
            r="7"
            stroke={colors.gray500}
            strokeWidth="2"
          />
          <path
            d="M20 20L16.5 16.5"
            stroke={colors.gray500}
            strokeWidth="2"
            strokeLinecap="round"
          />
        </svg>
      </SearchIcon>
      <SearchInput
        type="text"
        placeholder="장례식장 이름으로 검색"
        value={value}
        onChange={(e) => onChange(e.target.value)}
      />
      {value && (
        <ClearButton onClick={() => onChange("")} aria-label="검색어 지우기">
          ×
        </ClearButton>
      )}
    </SearchRoot>
  );
};

const SearchRoot = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  margin: 0 16px 4px;
  background: ${colors.gray50};
  border-radius: 8px;
  border: 1px solid ${colors.gray200};
`;

const SearchIcon = styled.div`
  position: absolute;
  left: 12px;
  display: flex;
  align-items: center;
`;

const SearchInput = styled.input`
  width: 100%;
  padding: 11px 36px 11px 38px;
  font-size: 14px;
  background: transparent;
  border: none;
  outline: none;
  color: ${colors.gray800};

  &::placeholder {
    color: ${colors.gray400};
  }
`;

const ClearButton = styled.button`
  position: absolute;
  right: 10px;
  font-size: 18px;
  color: ${colors.gray400};
  background: none;
  border: none;
  cursor: pointer;
  line-height: 1;
  padding: 2px 4px;
`;
